/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HoldCreatedShow
 */
export interface HoldCreatedShow {
    /**
     *
     * @type {string}
     * @memberof HoldCreatedShow
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof HoldCreatedShow
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof HoldCreatedShow
     */
    status: string;
}

/**
 * Check if a given object implements the HoldCreatedShow interface.
 */
export function instanceOfHoldCreatedShow(value: object): value is HoldCreatedShow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function HoldCreatedShowFromJSON(json: any): HoldCreatedShow {
    return HoldCreatedShowFromJSONTyped(json, false);
}

export function HoldCreatedShowFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldCreatedShow {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'title': json['title'],
        'status': json['status'],
    };
}

  export function HoldCreatedShowToJSON(json: any): HoldCreatedShow {
      return HoldCreatedShowToJSONTyped(json, false);
  }

  export function HoldCreatedShowToJSONTyped(value?: HoldCreatedShow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'title': value['title'],
        'status': value['status'],
    };
}
